import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, OnInit, AfterViewInit, VERSION, ViewChild, forwardRef, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormArray, FormBuilder, FormGroup, Validators, ReactiveFormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService, NgxSpinnerModule } from 'ngx-spinner';
import { LocalStorageService } from '../../services/storage/local-storage.service';
import { NgxTrimDirectiveModule } from 'ngx-trim-directive';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { DataService } from '../../services/data/data.service';
import { ClaimantService } from '../../services/claimant/claimant.service';
import { Claimant } from '../../models/claimant';
import { Authenticate } from '../../models/authenticate';

import { RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha-2';
import { MatStepper, MatStepperModule } from '@angular/material/stepper';
import { MustMatch } from '../../helpers/must-match.validator';
import { requiredIfValidator2 } from '../../helpers/check-required-private.validator';
import { requiredIfValidator } from '../../helpers/check-required-purchaser.validator';


@Component({
  selector: 'app-file-noticed',
  templateUrl: './file-noticed.html',
  styleUrls: ['./file-noticed.css'],
  imports: [ReactiveFormsModule, CommonModule, NgxTrimDirectiveModule, NgxMaskDirective, NgxSpinnerModule, RecaptchaModule, RecaptchaFormsModule, MatStepperModule],
  providers: [provideNgxMask()], // Provide at the component level
})
export class NoticedFile implements OnInit, AfterViewInit {
  @ViewChild('listofFiles') tableRef: ElementRef;
  @ViewChild('fileInput') fileInput: ElementRef;
  @ViewChild('stepper') stepper: MatStepper;
  @ViewChild('name') name: ElementRef;

  purchasesDatePickerConfig: any;
  salesDatePickerConfig: any;
  purchasesNotesDatePickerConfig: any;
  salesNotesDatePickerConfig: any;
  showDivPrivacyClassCheckboxes: boolean = false;
  showDivPurchaserClassCheckboxes: boolean = false;
  showDivForPurchaseMaximumhit: boolean = false;
  showDivForPrivacyMaximumhit: boolean = false;
  clicked: boolean = false;
  submitClicked: boolean = false;
  showMessage: boolean = false;
  submitted: boolean = false;
  isLinear: boolean = false; // Set to true for linear progression
  showDivForNonUS: boolean = false;
  showDivProvince: boolean = false;
  showDivStateZip: boolean = true;
  showSSNTINRow: boolean = false;
  showDivlast4SSN: boolean = false;
  showDivTIN: boolean = false;
  showDivForUS: boolean = false;
  showDivOptSectionA: boolean = false;
  showDivOptSectionB: boolean = false;
  showDivOtherRelationshipType: boolean = false;
  showDivOtherHealthType: boolean = false;
  showDivOtherClaimantAccountType: boolean = false;
  showPurchaserSettlementClass: boolean = false;
  showDivPrivacySettlementClass: boolean = false;
  showDivNoDocsMessage: boolean = false;
  showDivPurchaserClass: boolean = false;
  showDivNotPrivacy: boolean = false;
  showDivNotPurchaser: boolean = false;
  showDivACH: boolean = false;
  showSubmittalErrorWarning: boolean = false;
  showDivForPurchaserMinimumhit: boolean = false;
  showDivForPrivacyMinimumhit: boolean = false;
  showDivForPaymentOptionRequired: boolean = false;
  changed = false;
  stepLoginForm: FormGroup;
  stepOneForm: FormGroup;
  stepTwoForm: FormGroup;
  stepThreeForm: FormGroup;
  stepFiveForm: FormGroup;
  stepFourForm: FormGroup;
  claimStartTime: string;
  claimEndTime: string;
  stepSixForm: FormGroup;
  stepSevenForm: FormGroup;
  response: string | undefined;
  dateLoaded: Date;
  showDivSubmittalErrorMessage: boolean = false;
  showDivPrivacyClass: boolean = false;
  allStates: any = [];
  allCountries: any = [];
  allClaimantAccountTypes: any = [];
  saleList: any = [];
  purchaseList: any = [];
  openingList: any = [];
  lookbackList: any = [];
  closingList: any = [];
  lookbackNoteList: any = [];
  purchaseNoteList: any = [];
  saleNoteList: any = [];
  openingNoteList: any = [];
  closingNoteList: any = [];
  authenticatedUser: Authenticate;
  claimDetailList: any = [];
  supportingDocuments: File[] = [];

  public claimant: Claimant;
  public errorMessage: string = '';
  public showError: boolean;
  public submittedClaim: Claimant;

  validation_ClassMembersErrorMessage = {
    classMemberName: [
      { type: 'required', message: 'This Field is required' },
      { type: "minlength", message: "Field must be at least 2 characters" },
      { type: "maxlength", message: "Field cannot be more than 50 characters" },
      { type: "pattern", message: "Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)" }
    ],
    classMemberFEIN: [
      { type: 'required', message: 'This Field is required' },
      { type: "minlength", message: "Field must be at least 9 characters" },
      { type: "maxlength", message: "Field cannot be more than 9 characters" },
      { type: "pattern", message: "Only use numbers" }
    ],
  };

  validation_ClassMemberPaidAmountsErrorMessage = {
    classMemberName: [
      { type: 'required', message: 'This Field is required' },
      { type: "minlength", message: "Field must be at least 2 characters" },
      { type: "maxlength", message: "Field cannot be more than 50 characters" },
      { type: "pattern", message: "Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)" }
    ],
    classMemberPaidAmount: [
      { type: 'required', message: 'This Field is required' },
      { type: "maxlength", message: "Field cannot be more than 15 digits" },
      { type: "pattern", message: "Only use numbers with optional period (.) and up to 4 digits past decimal" }
    ],
  };


  constructor(private fb: FormBuilder,
    private httpClient: HttpClient,
    private storage: LocalStorageService,
    private dataService: DataService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private cdr: ChangeDetectorRef,
    private claimantService: ClaimantService) { }


  ngAfterViewInit() {
    // Scroll to top on every step transition so short steps don't render
    // below the current scroll position after a long step (e.g. Claimant Information).
    this.stepper.selectionChange.subscribe(() => {
      window.scrollTo({ top: 0, behavior: 'auto' });
    });
  }

  ngOnInit() {
    this.loadAllStates();
    this.loadAllCountries();
    this.loadAllClaimantAccountTypes();
    this.authenticatedUser = this.storage.retrieve('authenticatedUser');
    this.dateLoaded = new Date();
    this.claimStartTime = this.dateLoaded.toLocaleTimeString();

    this.stepOneForm = this.fb.group({
     
    });
    
    this.stepTwoForm = this.fb.group({
      optSectionRadio: ['', Validators.compose([Validators.required])],
      classMemberName: ['', Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      guardianName: ['', Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      street1: ['', Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      street2: ['', Validators.compose([Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      city: ['', Validators.compose([Validators.required, Validators.maxLength(40), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      state: ['', Validators.compose([Validators.required])],
      zip: ['', Validators.compose([Validators.required, Validators.pattern("^[0-9]{5}(?:-[0-9]{4})?$")])],
      claimsIncurredStreet1: ['', Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      claimsIncurredStreet2: ['', Validators.compose([Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      claimsIncurredCity: ['', Validators.compose([Validators.required, Validators.maxLength(40), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      claimsIncurredState: ['', Validators.compose([Validators.required])],
      claimsIncurredZip: ['', Validators.compose([Validators.required, Validators.pattern("^[0-9]{5}(?:-[0-9]{4})?$")])],
      primaryPhone: ['', Validators.compose([Validators.required, Validators.maxLength(10), Validators.minLength(10), Validators.pattern("^[0-9]+$")])],
      primaryPhoneType: ['', Validators.compose([Validators.required])],
      emailAddress: ['', Validators.compose([Validators.required, Validators.maxLength(255), Validators.pattern("[a-zA-Z0-9_\\.-]+@([a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,6}$")])],
      emailAddressVerify: ['', Validators.compose([Validators.required, Validators.maxLength(255), Validators.pattern("[a-zA-Z0-9_\\.-]+@([a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,6}$")])],
    }, {
      validator: MustMatch('emailAddress', 'emailAddressVerify')
    });
    this.stepThreeForm = this.fb.group({
      settlementClassPurchaser: ['', Validators.compose([Validators.required])],
      googleMadeDeviceEmailAddress: [''],
      modelName: [''],
      serialOrImeiNumberPurchaser: [''],
      proofOfPurchase: [''],
    });
    this.stepFourForm = this.fb.group({
      settlementClassPrivacy: ['', Validators.compose([Validators.required])],
      serialOrImeiNumberPrivacy: [''],
      userOrMember: [''],
      associatedGoogleAccountEmailAddress: [''],
      associatedGoogleAccountName: [''],
      googleDeviceType: [''],
      googleDeviceModelName: [''],
    });
    this.stepFiveForm = this.fb.group({

    });
    this.stepSixForm = this.fb.group({
      optPaymentRadio: ['', Validators.compose([Validators.required])],
      achAccountType: [''],
      achRoutingNumber: [''],
      achAccountNumber: [''],
    });
    this.stepSevenForm = this.fb.group({
      checkbox1: ['', Validators.compose([Validators.required])],
      checkbox2: ['', Validators.compose([Validators.required])],
      checkbox3: ['', Validators.compose([Validators.required])],
      checkbox4: ['', Validators.compose([Validators.required])],
      checkbox5: ['', Validators.compose([Validators.required])],
      checkbox6: ['', Validators.compose([Validators.required])],
      checkBoxMemberOfPurchaserClass: [false],
      checkboxPurchaserGoogleAccountConfirmation: [false],
      checkBoxMemberOfPrivacyClass: [false],

      attestMemberOfPrivacyClass: [false],
      attestMemberOfPrivacyClassSelection: [''],
      checkBoxPrivacyCommunicationsRecorded: [false],

      noticeId: [this.authenticatedUser.noticeId],
      uniqueId: [this.authenticatedUser.uniqueId],
      pin: [this.authenticatedUser.pin],

      signature: ['', Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      googleRecaptchaToken: ['', Validators.compose([Validators.required])],
     
    },

      {
        validator: (requiredIfValidator('checkBoxMemberOfPurchaserClass'))

      });
    this.stepSevenForm.patchValue({
      noticeId: this.authenticatedUser.noticeId,
      uniqueId: this.authenticatedUser.uniqueId,
      pin: this.authenticatedUser.pin,
  
    });
  }
  isExpanded = false;

  collapse() {
    this.isExpanded = false;
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
  }
  loadAllStates() {
    this.httpClient.get("assets/States.json").subscribe(data => {
      this.allStates = data;
    })
  }

  loadAllCountries() {
    this.httpClient.get("assets/Countries.json").subscribe(data => {
      this.allCountries = data;
    })
  }

  loadAllClaimantAccountTypes() {
    this.httpClient.get("assets/ClaimantAccountTypes.json").subscribe(data => {
      this.allClaimantAccountTypes = data;
    })
  }

  resolved(captchaResponse: string) {
    this.response = captchaResponse;
  }

  clearPurchaseCheckboxes() {
    this.stepSevenForm.get('checkBoxMemberOfPurchaserClass').setValue(false);
    this.stepSevenForm.get('checkboxPurchaserGoogleAccountConfirmation').setValue(false);
  }

  clearPrivacyCheckboxes() {
    this.stepSevenForm.get('checkBoxMemberOfPrivacyClass').setValue(false);
    this.stepSevenForm.get('attestMemberOfPrivacyClass').setValue(false);

    this.stepSevenForm.get('attestMemberOfPrivacyClassSelection').setValue('');
    this.stepSevenForm.get('attestMemberOfPrivacyClassSelection').clearValidators();
    this.stepSevenForm.get('attestMemberOfPrivacyClassSelection').updateValueAndValidity();
    this.stepSevenForm.get('attestMemberOfPrivacyClassSelection').markAsUntouched();
    this.stepSevenForm.get('attestMemberOfPrivacyClassSelection').markAsPristine();

    this.stepSevenForm.get('checkBoxPrivacyCommunicationsRecorded').setValue(false);
  }

  // convenience getter for easy access to form fields
  get f() { return this.stepTwoForm.controls; }
  get g() { return this.stepThreeForm.controls; }

  get h() { return this.stepFourForm.controls; }

  //get h() { return this.stepFourForm.controls; }
  get i() { return this.stepFiveForm.controls; }

  get j() { return this.stepSixForm.controls; }

  get k() { return this.stepSevenForm.controls; }

  done() {
    this.stepper.selected.completed = false;
    this.stepper.selected.editable = true;
    this.stepper.next();
    this.submitted = false;
  }

  edit() {
    this.stepper.selected.completed = false;
    this.stepper.selected.editable = true;
    this.stepper.previous();
  }

  //getPurchaserClassCheckboxValue($event) {
  //  const checkBoxMemberOfPurchaserClass = this.stepSevenForm.get('checkBoxMemberOfPurchaserClass');
  //  if (checkBoxMemberOfPurchaserClass.value === true) {
  //    this.showDivPurchaserClassCheckboxes = true;


  //    this.stepSevenForm.get('checkboxPurchaserGoogleAccountConfirmation').setValidators(Validators.compose([Validators.required]));

  //  }

  //  if (checkBoxMemberOfPurchaserClass.value === false) {
  //    this.showDivPurchaserClassCheckboxes = false;
  //    this.stepSevenForm.get('checkboxPurchaserGoogleAccountConfirmation').reset();
  //    this.stepSevenForm.get('checkboxPurchaserGoogleAccountConfirmation').clearValidators();
  //    this.stepSevenForm.get('checkboxPurchaserGoogleAccountConfirmation').updateValueAndValidity();
  //    this.stepSevenForm.get('checkboxPurchaserGoogleAccountConfirmation').setValue(false);

  //  }

  //}

  //getPrivacyClassCheckboxValue($event) {
  //  const checkBoxMemberOfPrivacyClass = this.stepSevenForm.get('checkBoxMemberOfPrivacyClass');
  //  if (checkBoxMemberOfPrivacyClass.value === true) {
  //    this.showDivPrivacyClassCheckboxes = true;


  //    this.stepSevenForm.get('attestMemberOfPrivacyClass').setValidators(Validators.compose([Validators.required]));
  //    this.stepSevenForm.get('attestMemberOfPrivacyClassSelection').setValidators(Validators.compose([Validators.required]));
  //    this.stepSevenForm.get('checkBoxPrivacyCommunicationsRecorded').setValidators(Validators.compose([Validators.required]));

  //  }

  //  if (checkBoxMemberOfPrivacyClass.value === false) {
  //    this.showDivPrivacyClassCheckboxes = false;

  //    this.stepSevenForm.get('attestMemberOfPrivacyClass').reset();
  //    this.stepSevenForm.get('attestMemberOfPrivacyClass').clearValidators();
  //    this.stepSevenForm.get('attestMemberOfPrivacyClass').updateValueAndValidity();

  //    this.stepSevenForm.get('attestMemberOfPrivacyClassSelection').reset();
  //    this.stepSevenForm.get('attestMemberOfPrivacyClassSelection').clearValidators();
  //    this.stepSevenForm.get('attestMemberOfPrivacyClassSelection').updateValueAndValidity();

  //    this.stepSevenForm.get('checkBoxPrivacyCommunicationsRecorded').reset();
  //    this.stepSevenForm.get('checkBoxPrivacyCommunicationsRecorded').clearValidators();
  //    this.stepSevenForm.get('checkBoxPrivacyCommunicationsRecorded').updateValueAndValidity();

  //    this.stepSevenForm.get('attestMemberOfPrivacyClass').setValue(false);
  //    this.stepSevenForm.get('checkBoxPrivacyCommunicationsRecorded').setValue(false);

  //  }

  //}

  getPurchaserClassValue($event) {
    if ($event.target.value === 'Yes') {
      this.showDivPurchaserClass = true;

      this.stepThreeForm.get('googleMadeDeviceEmailAddress').setValidators(Validators.compose([Validators.required, Validators.maxLength(255), Validators.pattern("[a-zA-Z0-9_\\.-]+@([a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,6}$")]));
      this.stepThreeForm.get('modelName').setValidators(Validators.compose([Validators.required, Validators.maxLength(150), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")]));
      this.stepThreeForm.get('serialOrImeiNumberPurchaser').setValidators(Validators.compose([Validators.required, Validators.minLength(10), Validators.maxLength(25), Validators.pattern("^[a-zA-Z0-9]+$")]));
      this.stepThreeForm.get('proofOfPurchase').setValidators(Validators.compose([Validators.required, Validators.maxLength(150), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")]));

      let one = this.stepThreeForm.get('modelName').value;
      var two = this.stepThreeForm.get('serialOrImeiNumberPurchaser').value;
      var three = this.stepThreeForm.get('proofOfPurchase').value;
      this.showDivForPurchaserMinimumhit = false;
      let counterVariable: number = 0;

      let apArrayLengthpurchaseList = this.purchaseList.length;

      if (apArrayLengthpurchaseList === counterVariable) {
        // Display Error Message
        this.showDivForPurchaserMinimumhit = true;
        return;
      }
      if ((one !== '') || (two !== '') || (three !== '')) {
        this.showMessage = true;
        return;
      }
      if ((one === '') || (two === '') || (three === '')) {
        this.showMessage = false;
      }
    }

    if ($event.target.value === 'No') {
      this.showDivPurchaserClass = false;

      this.stepThreeForm.get('googleMadeDeviceEmailAddress').reset();
      this.stepThreeForm.get('googleMadeDeviceEmailAddress').clearValidators();
      this.stepThreeForm.get('googleMadeDeviceEmailAddress').updateValueAndValidity();

      this.stepThreeForm.get('modelName').reset();
      this.stepThreeForm.get('modelName').clearValidators();
      this.stepThreeForm.get('modelName').updateValueAndValidity();

      this.stepThreeForm.get('serialOrImeiNumberPurchaser').reset();
      this.stepThreeForm.get('serialOrImeiNumberPurchaser').clearValidators();
      this.stepThreeForm.get('serialOrImeiNumberPurchaser').updateValueAndValidity();

      this.stepThreeForm.get('proofOfPurchase').reset();
      this.stepThreeForm.get('proofOfPurchase').clearValidators();
      this.stepThreeForm.get('proofOfPurchase').updateValueAndValidity();

      this.purchaseList.length = 0;
    }

  }

  getPrivateClassValue($event) {
    if ($event.target.value === 'Yes') {
      this.showDivPrivacyClass = true;


      this.stepFourForm.get('userOrMember').setValidators(Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")]));
      this.stepFourForm.get('associatedGoogleAccountName').setValidators(Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")]));
      this.stepFourForm.get('associatedGoogleAccountEmailAddress').setValidators(Validators.compose([Validators.required, Validators.maxLength(255), Validators.pattern("[a-zA-Z0-9_\\.-]+@([a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,6}$")]));
      this.stepFourForm.get('googleDeviceType').setValidators(Validators.compose([Validators.required, Validators.maxLength(150), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")]));
      this.stepFourForm.get('googleDeviceModelName').setValidators(Validators.compose([Validators.required, Validators.maxLength(150), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")]));
      this.stepFourForm.get('serialOrImeiNumberPrivacy').setValidators(Validators.compose([Validators.required, Validators.minLength(10), Validators.maxLength(25), Validators.pattern("^[a-zA-Z0-9]+$")]));
      let one = this.stepFourForm.get('googleDeviceType').value;
      var two = this.stepFourForm.get('googleDeviceModelName').value;
      var three = this.stepFourForm.get('serialOrImeiNumberPrivacy').value;

      let counterVariable: number = 0;

      let apArrayLengthpurchaseList = this.saleList.length;

      if (apArrayLengthpurchaseList === counterVariable) {
        // Display Error Message
        this.showDivForPrivacyMinimumhit = true;
        return;
      }

      if ((one !== '') || (two !== '') || (three !== '')) {
        this.showMessage = true;
        return;
      }
      if ((one === '') || (two === '') || (three === '')) {
        this.showMessage = false;
      }
    }

    if ($event.target.value === 'No') {
      this.showDivPrivacyClass = false;

      this.stepFourForm.get('userOrMember').reset();
      this.stepFourForm.get('userOrMember').clearValidators();
      this.stepFourForm.get('userOrMember').updateValueAndValidity();

      this.stepFourForm.get('associatedGoogleAccountName').reset();
      this.stepFourForm.get('associatedGoogleAccountName').clearValidators();
      this.stepFourForm.get('associatedGoogleAccountName').updateValueAndValidity();

      this.stepFourForm.get('associatedGoogleAccountEmailAddress').reset();
      this.stepFourForm.get('associatedGoogleAccountEmailAddress').clearValidators();
      this.stepFourForm.get('associatedGoogleAccountEmailAddress').updateValueAndValidity();

      this.stepFourForm.get('serialOrImeiNumberPrivacy').reset();
      this.stepFourForm.get('serialOrImeiNumberPrivacy').clearValidators();
      this.stepFourForm.get('serialOrImeiNumberPrivacy').updateValueAndValidity();

      this.stepFourForm.get('googleDeviceType').reset();
      this.stepFourForm.get('googleDeviceType').clearValidators();
      this.stepFourForm.get('googleDeviceType').updateValueAndValidity();

      this.stepFourForm.get('googleDeviceModelName').reset();
      this.stepFourForm.get('googleDeviceModelName').clearValidators();
      this.stepFourForm.get('googleDeviceModelName').updateValueAndValidity();

      this.saleList.length = 0;
    }

  }

  getRadioOptSectionRadioValue($event) {
    // if you need the event source and value it can be accessed.
    console.log($event.target.value);
    if ($event.target.value === 'Under18') {
      this.showDivOptSectionA = true;
      this.showDivOptSectionB = false;
      this.showDivOtherRelationshipType = false;
      this.stepTwoForm.get('classMemberName').reset();
      this.stepTwoForm.get('classMemberName').clearValidators();
      this.stepTwoForm.get('classMemberName').updateValueAndValidity();

      this.stepTwoForm.get('guardianName').reset();
      this.stepTwoForm.get('guardianName').clearValidators();
      this.stepTwoForm.get('guardianName').updateValueAndValidity();

      this.stepTwoForm.get('street1').reset();
      this.stepTwoForm.get('street1').clearValidators();
      this.stepTwoForm.get('street1').updateValueAndValidity();

      this.stepTwoForm.get('street2').reset();
      this.stepTwoForm.get('street2').clearValidators();
      this.stepTwoForm.get('street2').updateValueAndValidity();

      this.stepTwoForm.get('city').reset();
      this.stepTwoForm.get('city').clearValidators();
      this.stepTwoForm.get('city').updateValueAndValidity();

      this.stepTwoForm.get('state').reset();
      this.stepTwoForm.get('state').clearValidators();
      this.stepTwoForm.get('state').updateValueAndValidity();

      this.stepTwoForm.get('zip').reset();
      this.stepTwoForm.get('zip').clearValidators();
      this.stepTwoForm.get('zip').updateValueAndValidity();

      this.stepTwoForm.get('claimsIncurredStreet1').reset();
      this.stepTwoForm.get('claimsIncurredStreet1').clearValidators();
      this.stepTwoForm.get('claimsIncurredStreet1').updateValueAndValidity();

      this.stepTwoForm.get('claimsIncurredStreet2').reset();
      this.stepTwoForm.get('claimsIncurredStreet2').clearValidators();
      this.stepTwoForm.get('claimsIncurredStreet2').updateValueAndValidity();

      this.stepTwoForm.get('claimsIncurredCity').reset();
      this.stepTwoForm.get('claimsIncurredCity').clearValidators();
      this.stepTwoForm.get('claimsIncurredCity').updateValueAndValidity();

      this.stepTwoForm.get('claimsIncurredState').reset();
      this.stepTwoForm.get('claimsIncurredState').clearValidators();
      this.stepTwoForm.get('claimsIncurredState').updateValueAndValidity();

      this.stepTwoForm.get('claimsIncurredZip').reset();
      this.stepTwoForm.get('claimsIncurredZip').clearValidators();
      this.stepTwoForm.get('claimsIncurredZip').updateValueAndValidity();

      this.stepTwoForm.get('primaryPhone').reset();
      this.stepTwoForm.get('primaryPhone').clearValidators();
      this.stepTwoForm.get('primaryPhone').updateValueAndValidity();

      this.stepTwoForm.get('primaryPhoneType').reset();
      this.stepTwoForm.get('primaryPhoneType').clearValidators();
      this.stepTwoForm.get('primaryPhoneType').updateValueAndValidity();

      this.stepTwoForm.get('emailAddress').reset();
      this.stepTwoForm.get('emailAddress').clearValidators();
      this.stepTwoForm.get('emailAddress').updateValueAndValidity();

      this.stepTwoForm.get('emailAddressVerify').reset();
      this.stepTwoForm.get('emailAddressVerify').clearValidators();
      this.stepTwoForm.get('emailAddressVerify').updateValueAndValidity();




      this.stepTwoForm.get('filerType')?.setValue($event.target.value);
      this.stepTwoForm.get('classMemberName').setValidators(Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")]));
      // Issue 1995: Guardian name must be required for Under 18
      this.stepTwoForm.get('guardianName').setValidators(Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")]));
      this.stepTwoForm.get('street1').setValidators(Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")]));
      this.stepTwoForm.get('street2').setValidators(Validators.compose([Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")]));
      this.stepTwoForm.get('city').setValidators(Validators.compose([Validators.required, Validators.maxLength(40), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")]));
      this.stepTwoForm.get('state').setValidators(Validators.compose([Validators.required]));
      this.stepTwoForm.get('zip').setValidators(Validators.compose([Validators.required, Validators.pattern("^[0-9]{5}(?:-[0-9]{4})?$")]));
      this.stepTwoForm.get('claimsIncurredStreet1').setValidators(Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")]));
      this.stepTwoForm.get('claimsIncurredStreet2').setValidators(Validators.compose([Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")]));
      this.stepTwoForm.get('claimsIncurredCity').setValidators(Validators.compose([Validators.required, Validators.maxLength(40), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")]));
      this.stepTwoForm.get('claimsIncurredState').setValidators(Validators.compose([Validators.required]));
      this.stepTwoForm.get('claimsIncurredZip').setValidators(Validators.compose([Validators.required, Validators.pattern("^[0-9]{5}(?:-[0-9]{4})?$")]));
      this.stepTwoForm.get('primaryPhone').setValidators(Validators.compose([Validators.required, Validators.maxLength(10), Validators.minLength(10), Validators.pattern("^[0-9]+$")]));
      this.stepTwoForm.get('primaryPhoneType').setValidators(Validators.compose([Validators.required]));
      this.stepTwoForm.get('emailAddress').setValidators(Validators.compose([Validators.required, Validators.maxLength(255), Validators.pattern("[a-zA-Z0-9_\\.-]+@([a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,6}$")]));
      this.stepTwoForm.get('emailAddressVerify').setValidators(Validators.compose([Validators.required, Validators.maxLength(255), Validators.pattern("[a-zA-Z0-9_\\.-]+@([a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,6}$")]));
    }

    if ($event.target.value === 'Over18') {
      this.showDivOptSectionB = true;
      this.showDivOptSectionA = false;
      this.showDivOtherHealthType = false;

      this.stepTwoForm.get('classMemberName').reset();
      this.stepTwoForm.get('classMemberName').clearValidators();
      this.stepTwoForm.get('classMemberName').updateValueAndValidity();

      this.stepTwoForm.get('guardianName').reset();
      this.stepTwoForm.get('guardianName').clearValidators();
      this.stepTwoForm.get('guardianName').updateValueAndValidity();

      this.stepTwoForm.get('street1').reset();
      this.stepTwoForm.get('street1').clearValidators();
      this.stepTwoForm.get('street1').updateValueAndValidity();

      this.stepTwoForm.get('street2').reset();
      this.stepTwoForm.get('street2').clearValidators();
      this.stepTwoForm.get('street2').updateValueAndValidity();

      this.stepTwoForm.get('city').reset();
      this.stepTwoForm.get('city').clearValidators();
      this.stepTwoForm.get('city').updateValueAndValidity();

      this.stepTwoForm.get('state').reset();
      this.stepTwoForm.get('state').clearValidators();
      this.stepTwoForm.get('state').updateValueAndValidity();

      this.stepTwoForm.get('zip').reset();
      this.stepTwoForm.get('zip').clearValidators();
      this.stepTwoForm.get('zip').updateValueAndValidity();

      this.stepTwoForm.get('claimsIncurredStreet1').reset();
      this.stepTwoForm.get('claimsIncurredStreet1').clearValidators();
      this.stepTwoForm.get('claimsIncurredStreet1').updateValueAndValidity();

      this.stepTwoForm.get('claimsIncurredStreet2').reset();
      this.stepTwoForm.get('claimsIncurredStreet2').clearValidators();
      this.stepTwoForm.get('claimsIncurredStreet2').updateValueAndValidity();

      this.stepTwoForm.get('claimsIncurredCity').reset();
      this.stepTwoForm.get('claimsIncurredCity').clearValidators();
      this.stepTwoForm.get('claimsIncurredCity').updateValueAndValidity();

      this.stepTwoForm.get('claimsIncurredState').reset();
      this.stepTwoForm.get('claimsIncurredState').clearValidators();
      this.stepTwoForm.get('claimsIncurredState').updateValueAndValidity();

      this.stepTwoForm.get('claimsIncurredZip').reset();
      this.stepTwoForm.get('claimsIncurredZip').clearValidators();
      this.stepTwoForm.get('claimsIncurredZip').updateValueAndValidity();

      this.stepTwoForm.get('primaryPhone').reset();
      this.stepTwoForm.get('primaryPhone').clearValidators();
      this.stepTwoForm.get('primaryPhone').updateValueAndValidity();

      this.stepTwoForm.get('primaryPhoneType').reset();
      this.stepTwoForm.get('primaryPhoneType').clearValidators();
      this.stepTwoForm.get('primaryPhoneType').updateValueAndValidity();

      this.stepTwoForm.get('emailAddress').reset();
      this.stepTwoForm.get('emailAddress').clearValidators();
      this.stepTwoForm.get('emailAddress').updateValueAndValidity();

      this.stepTwoForm.get('emailAddressVerify').reset();
      this.stepTwoForm.get('emailAddressVerify').clearValidators();
      this.stepTwoForm.get('emailAddressVerify').updateValueAndValidity();

      this.stepTwoForm.get('filerType')?.setValue($event.target.value);
      this.stepTwoForm.get('classMemberName').setValidators(Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")]));
      this.stepTwoForm.get('street1').setValidators(Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")]));
      this.stepTwoForm.get('street2').setValidators(Validators.compose([Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")]));
      this.stepTwoForm.get('city').setValidators(Validators.compose([Validators.required, Validators.maxLength(40), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")]));
      this.stepTwoForm.get('state').setValidators(Validators.compose([Validators.required]));
      this.stepTwoForm.get('zip').setValidators(Validators.compose([Validators.required, Validators.pattern("^[0-9]{5}(?:-[0-9]{4})?$")]));
      this.stepTwoForm.get('claimsIncurredStreet1').setValidators(Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")]));
      this.stepTwoForm.get('claimsIncurredStreet2').setValidators(Validators.compose([Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")]));
      this.stepTwoForm.get('claimsIncurredCity').setValidators(Validators.compose([Validators.required, Validators.maxLength(40), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")]));
      this.stepTwoForm.get('claimsIncurredState').setValidators(Validators.compose([Validators.required]));
      this.stepTwoForm.get('claimsIncurredZip').setValidators(Validators.compose([Validators.required, Validators.pattern("^[0-9]{5}(?:-[0-9]{4})?$")]));
      this.stepTwoForm.get('primaryPhone').setValidators(Validators.compose([Validators.required, Validators.maxLength(10), Validators.minLength(10), Validators.pattern("^[0-9]+$")]));
      this.stepTwoForm.get('primaryPhoneType').setValidators(Validators.compose([Validators.required]));
      this.stepTwoForm.get('emailAddress').setValidators(Validators.compose([Validators.required, Validators.maxLength(255), Validators.pattern("[a-zA-Z0-9_\\.-]+@([a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,6}$")]));
      this.stepTwoForm.get('emailAddressVerify').setValidators(Validators.compose([Validators.required, Validators.maxLength(255), Validators.pattern("[a-zA-Z0-9_\\.-]+@([a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,6}$")]));
    }
  }

  getPaymentRadioValue($event) {
    // if you need the event source and value it can be accessed.
    console.log($event.target.value);
    this.showDivForPaymentOptionRequired = false;
    if ($event.target.value === 'ACH') {
      this.showDivACH = true;
      //this.stepFiveForm.get('achAccountType').reset();
      //this.stepFiveForm.get('achAccountType').clearValidators();
      //this.stepFiveForm.get('achAccountType').updateValueAndValidity();

      //this.stepFiveForm.get('achRoutingNumber').reset();
      //this.stepFiveForm.get('achRoutingNumber').clearValidators();
      //this.stepFiveForm.get('achRoutingNumber').updateValueAndValidity();

      //this.stepFiveForm.get('achAccountNumber').reset();
      //this.stepFiveForm.get('achAccountNumber').clearValidators();
      //this.stepFiveForm.get('achAccountNumber').updateValueAndValidity();

      this.stepSixForm.get('achAccountType').setValidators(Validators.compose([Validators.required]));
      this.stepSixForm.get('achRoutingNumber').setValidators(Validators.compose([Validators.required, Validators.maxLength(9), Validators.minLength(9), Validators.pattern("^[0-9]+$")]));
      this.stepSixForm.get('achAccountNumber').setValidators(Validators.compose([Validators.required, Validators.minLength(8), Validators.maxLength(17), Validators.pattern("^[0-9]+$")]));
    }
    if ($event.target.value === 'Zelle') {
      this.showDivACH = false;
      this.stepSixForm.get('achAccountType').reset();
      this.stepSixForm.get('achAccountType').clearValidators();
      this.stepSixForm.get('achAccountType').updateValueAndValidity();

      this.stepSixForm.get('achRoutingNumber').reset();
      this.stepSixForm.get('achRoutingNumber').clearValidators();
      this.stepSixForm.get('achRoutingNumber').updateValueAndValidity();

      this.stepSixForm.get('achAccountNumber').reset();
      this.stepSixForm.get('achAccountNumber').clearValidators();
      this.stepSixForm.get('achAccountNumber').updateValueAndValidity();
    }
    if ($event.target.value === 'PayPal') {
      this.showDivACH = false;
      this.stepSixForm.get('achAccountType').reset();
      this.stepSixForm.get('achAccountType').clearValidators();
      this.stepSixForm.get('achAccountType').updateValueAndValidity();

      this.stepSixForm.get('achRoutingNumber').reset();
      this.stepSixForm.get('achRoutingNumber').clearValidators();
      this.stepSixForm.get('achRoutingNumber').updateValueAndValidity();

      this.stepSixForm.get('achAccountNumber').reset();
      this.stepSixForm.get('achAccountNumber').clearValidators();
      this.stepSixForm.get('achAccountNumber').updateValueAndValidity();
    }
    if ($event.target.value === 'Venmo') {
      this.showDivACH = false;
      this.stepSixForm.get('achAccountType').reset();
      this.stepSixForm.get('achAccountType').clearValidators();
      this.stepSixForm.get('achAccountType').updateValueAndValidity();

      this.stepSixForm.get('achRoutingNumber').reset();
      this.stepSixForm.get('achRoutingNumber').clearValidators();
      this.stepSixForm.get('achRoutingNumber').updateValueAndValidity();

      this.stepSixForm.get('achAccountNumber').reset();
      this.stepSixForm.get('achAccountNumber').clearValidators();
      this.stepSixForm.get('achAccountNumber').updateValueAndValidity();
    }
    if ($event.target.value === 'Paper Check') {
      this.showDivACH = false;
      this.stepSixForm.get('achAccountType').reset();
      this.stepSixForm.get('achAccountType').clearValidators();
      this.stepSixForm.get('achAccountType').updateValueAndValidity();

      this.stepSixForm.get('achRoutingNumber').reset();
      this.stepSixForm.get('achRoutingNumber').clearValidators();
      this.stepSixForm.get('achRoutingNumber').updateValueAndValidity();

      this.stepSixForm.get('achAccountNumber').reset();
      this.stepSixForm.get('achAccountNumber').clearValidators();
      this.stepSixForm.get('achAccountNumber').updateValueAndValidity();
    }
  }


  saveAndValidateStepTwo() {



    // stop here if form is invalid
    if (this.stepTwoForm.invalid) {
      return;
    }


    //this.stepper.selected.completed = false;
    //this.stepper.selected.editable = true;  
    /*this.submitted = false;*/
    let test = this.stepTwoForm.value;
    this.dataService.stepTwoSharedData = test;
    this.stepper.next();
  }

  saveAndValidateStepThree() {

    // stop here if form is invalid
    if (this.stepThreeForm.invalid) {
      return;
    }

    // Issue 1298: Block navigation if Purchaser Class is Yes but no entries exist
    if (this.stepThreeForm.get('settlementClassPurchaser').value === 'Yes' && this.purchaseList.length === 0) {
      this.showDivForPurchaserMinimumhit = true;
      return;
    }

    let one = this.stepThreeForm.get('modelName').value;
    var two = this.stepThreeForm.get('serialOrImeiNumberPurchaser').value;
    var three = this.stepThreeForm.get('proofOfPurchase').value;



    if (this.showDivPurchaserClass == true) {

      if ((one !== '') || (two !== '') || (three !== '')) {
        this.showMessage = true;
        return;
      }
      if ((one === '') || (two === '') || (three === '')) {
        this.showMessage = false;
      }
    }


    //let counterVariable: number = 0;
    //let apArrayLengthpurchaseList = this.purchaseList.length;


    //if (apArrayLengthpurchaseList === counterVariable && (this.showDivPurchaserClass == true)) {
    //  // Display Error Message
    //  this.showDivForPurchaserMinimumhit = true;
    //  return;
    //}
    //if (apArrayLengthpurchaseList !== counterVariable && (this.showDivPurchaserClass == true)) {
    //  // Display Error Message
    //  this.showDivForPurchaserMinimumhit = false;

    //}

    //if (apArrayLengthprivacyList === counterVariable) {
    //  // Display Error Message
    //  this.showDivForPrivacyMinimumhit = true;
    //  return;
    //}
    //if (apArrayLengthprivacyList !== counterVariable) {
    //  // Display Error Message
    //  this.showDivForPrivacyMinimumhit = false;

    //}

    let test = this.stepThreeForm.value;
    this.dataService.stepThreeSharedData = test;
    this.dataService.stepThreeSharedDataPurchases = this.purchaseList;
    this.stepper.next();
  }

  saveAndValidateStepFour() {

    // stop here if form is invalid
    if (this.stepFourForm.invalid) {
      return;
    }

    // Issue 1299: Block navigation if Privacy Class is Yes but no entries exist
    if (this.stepFourForm.get('settlementClassPrivacy').value === 'Yes' && this.saleList.length === 0) {
      this.showDivForPrivacyMinimumhit = true;
      return;
    }

    let one = this.stepFourForm.get('googleDeviceType').value;
    var two = this.stepFourForm.get('googleDeviceModelName').value;
    var three = this.stepFourForm.get('serialOrImeiNumberPrivacy').value;



    if (this.showDivPrivacyClass == true) {

      if ((one !== '') || (two !== '') || (three !== '')) {
        this.showMessage = true;
        return;
      }
      if ((one === '') || (two === '') || (three === '')) {
        this.showMessage = false;
      }
    }

    //let one = this.stepThreeForm.get('modelName').value;
    //var two = this.stepThreeForm.get('serialOrImeiNumber').value;
    //var three = this.stepThreeForm.get('proofOfPurchase').value;
    //var four = this.stepThreeForm.get('googleDeviceType').value;
    //var five = this.stepThreeForm.get('googleDeviceModelName').value;


    //if ((one !== '') || (two !== '') || (three !== '') || (four !== '') || (five !== '') && (this.showDivForPurchaserMinimumhit == true || this.showDivForPrivacyMinimumhit == true)) {
    //  this.showMessage = true;
    //  return;
    //}
    //if ((one === '') || (two === '') || (three === '') || (four === '') || (five === '')) {
    //  this.showMessage = false;
    //}

    //let counterVariable: number = 0;
    //let apArrayLengthpurchaseList = this.purchaseList.length;
    //let apArrayLengthprivacyList = this.saleList.length;


    //if (apArrayLengthpurchaseList === counterVariable) {
    //  // Display Error Message
    //  this.showDivForPurchaserMinimumhit = true;
    //  return;
    //}
    //if (apArrayLengthpurchaseList !== counterVariable) {
    //  // Display Error Message
    //  this.showDivForPurchaserMinimumhit = false;

    //}

    //if (apArrayLengthprivacyList === counterVariable) {
    //  // Display Error Message
    //  this.showDivForPrivacyMinimumhit = true;
    //  return;
    //}
    //if (apArrayLengthprivacyList !== counterVariable) {
    //  // Display Error Message
    //  this.showDivForPrivacyMinimumhit = false;

    //}

    let test = this.stepFourForm.value;
    this.dataService.stepFourSharedData = test;
    this.dataService.stepFourSharedDataSales = this.saleList;
    this.stepper.next();
  }

  saveAndValidateStepFive() {
    //this.stepper.selected.completed = false;
    //this.stepper.selected.editable = true;  
    /*this.submitted = false;*/
    let test = this.supportingDocuments;
    this.dataService.stepFiveSharedData = test;
    this.stepper.next();
  }

  saveAndValidateStepSix() {
    //this.stepper.selected.completed = false;
    //this.stepper.selected.editable = true;
    /*this.submitted = false;*/
    if (!this.stepSixForm.get('optPaymentRadio').value) {
      this.showDivForPaymentOptionRequired = true;
      return;
    }

    if (this.stepSixForm.invalid) {
      return;
    }

    this.showDivForPaymentOptionRequired = false;
    let test = this.stepSixForm.value;
    this.dataService.stepSixSharedData = test;
    this.stepper.next();
  }


  onBlur(event) {
    if (event.target.value !== '')
      event.target.value = parseFloat(event.target.value).toFixed(2)
  }

  // Remove the second element and so on
  removeAllExceptFirst(formArray: FormArray): void {
    while (formArray.length > 1) {
      formArray.removeAt(0);
    }
  }

  removeTable() {
    if (this.tableRef) {
      this.tableRef.nativeElement.remove();
    }
  }

  getBeneficialOwnerTypeValue($event) {
    // Access the event source and value.
    if ($event.target.value === 'Other') {
      this.showDivOtherClaimantAccountType = true;
      this.stepTwoForm.get('otherBeneficialOwnerType').setValidators(Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")]));
    }

    if ($event.target.value !== 'Other') {
      this.showDivOtherClaimantAccountType = false;
      this.stepTwoForm.get('otherBeneficialOwnerType').clearValidators();
      this.stepTwoForm.get('otherBeneficialOwnerType').updateValueAndValidity();
      this.stepTwoForm.get('otherBeneficialOwnerType').reset();
    }
  }

  clearPurchasesData() {




    this.stepThreeForm.get('modelName').setValue('');
    this.stepThreeForm.get('modelName').clearValidators();
    this.stepThreeForm.get('modelName').updateValueAndValidity();
    this.stepThreeForm.get('modelName').markAsUntouched();
    this.stepThreeForm.get('modelName').markAsPristine();

    this.stepThreeForm.get('serialOrImeiNumberPurchaser').setValue('');
    this.stepThreeForm.get('serialOrImeiNumberPurchaser').clearValidators();
    this.stepThreeForm.get('serialOrImeiNumberPurchaser').updateValueAndValidity();
    this.stepThreeForm.get('serialOrImeiNumberPurchaser').markAsUntouched();
    this.stepThreeForm.get('serialOrImeiNumberPurchaser').markAsPristine();

    this.stepThreeForm.get('proofOfPurchase').setValue('');
    this.stepThreeForm.get('proofOfPurchase').clearValidators();
    this.stepThreeForm.get('proofOfPurchase').updateValueAndValidity();
    this.stepThreeForm.get('proofOfPurchase').markAsUntouched();
    this.stepThreeForm.get('proofOfPurchase').markAsPristine();
    this.showMessage = false;

  }

  clearSalesData() {
    this.stepFourForm.get('googleDeviceType').setValue('');
    this.stepFourForm.get('googleDeviceType').clearValidators();
    this.stepFourForm.get('googleDeviceType').updateValueAndValidity();
    this.stepFourForm.get('googleDeviceType').markAsUntouched();
    this.stepFourForm.get('googleDeviceType').markAsPristine();

    this.stepFourForm.get('googleDeviceModelName').setValue('');
    this.stepFourForm.get('googleDeviceModelName').clearValidators();
    this.stepFourForm.get('googleDeviceModelName').updateValueAndValidity();
    this.stepFourForm.get('googleDeviceModelName').markAsUntouched();
    this.stepFourForm.get('googleDeviceModelName').markAsPristine();

    this.stepFourForm.get('serialOrImeiNumberPrivacy').setValue('');
    this.stepFourForm.get('serialOrImeiNumberPrivacy').clearValidators();
    this.stepFourForm.get('serialOrImeiNumberPrivacy').updateValueAndValidity();
    this.stepFourForm.get('serialOrImeiNumberPrivacy').markAsUntouched();
    this.stepFourForm.get('serialOrImeiNumberPrivacy').markAsPristine();

    this.showMessage = false;
  }

  addPurchasesData() {
    let counterVariable: number = 3;

    let apArrayLengthpurchaseList = this.purchaseList.length;

    if (apArrayLengthpurchaseList === counterVariable) {
      // Display Error Message
      this.showDivForPurchaseMaximumhit = true;
      return;
    }

    this.clicked = true;
    this.stepThreeForm.get('modelName').setValidators(Validators.compose([Validators.required, Validators.minLength(2), Validators.maxLength(150), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")]));
    this.stepThreeForm.get('modelName').updateValueAndValidity();

    this.stepThreeForm.get('serialOrImeiNumberPurchaser').setValidators(Validators.compose([Validators.required, Validators.minLength(10), Validators.maxLength(25), Validators.pattern("^[a-zA-Z0-9]+$")]));
    this.stepThreeForm.get('serialOrImeiNumberPurchaser').updateValueAndValidity();

    this.stepThreeForm.get('proofOfPurchase').setValidators(Validators.compose([Validators.required, Validators.minLength(2), Validators.maxLength(150), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")]));
    this.stepThreeForm.get('proofOfPurchase').updateValueAndValidity();

    if (this.stepThreeForm.get('modelName').invalid || this.stepThreeForm.get('serialOrImeiNumberPurchaser').invalid || this.stepThreeForm.get('proofOfPurchase').invalid) {
      return;
    }

    const options: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    };

    let pL = new Array();

    pL = [{
      TableType: 'Purchaser',
      ModelName: this.stepThreeForm.get('modelName').value,
      SerialOrImeiNumberPurchaser: this.stepThreeForm.get('serialOrImeiNumberPurchaser').value,
      ProofOfPurchase: this.stepThreeForm.get('proofOfPurchase').value,
    }];

    for (let i = 0; i < pL.length; i++) {
      this.purchaseList.push(pL[i]);
    }

    // Issue 1300: Clear minimum entry warning after adding first entry
    this.showDivForPurchaserMinimumhit = false;

    this.stepThreeForm.get('modelName').setValue('');
    this.stepThreeForm.get('modelName').clearValidators();
    this.stepThreeForm.get('modelName').updateValueAndValidity();
    this.stepThreeForm.get('modelName').markAsUntouched();
    this.stepThreeForm.get('modelName').markAsPristine();

    this.stepThreeForm.get('serialOrImeiNumberPurchaser').setValue('');
    this.stepThreeForm.get('serialOrImeiNumberPurchaser').clearValidators();
    this.stepThreeForm.get('serialOrImeiNumberPurchaser').updateValueAndValidity();
    this.stepThreeForm.get('serialOrImeiNumberPurchaser').markAsUntouched();
    this.stepThreeForm.get('serialOrImeiNumberPurchaser').markAsPristine();

    this.stepThreeForm.get('proofOfPurchase').setValue('');
    this.stepThreeForm.get('proofOfPurchase').clearValidators();
    this.stepThreeForm.get('proofOfPurchase').updateValueAndValidity();
    this.stepThreeForm.get('proofOfPurchase').markAsUntouched();
    this.stepThreeForm.get('proofOfPurchase').markAsPristine();

    this.showMessage = false;
    this.clicked = false;


    /* (<FormArray>this.stepThreeForm.get('purchases')).push(this.newPurchase());*/
  }

  addSalesData() {
    let counterVariable: number = 1;

    let apArrayLengthpurchaseList = this.saleList.length;

    if (apArrayLengthpurchaseList === counterVariable) {
      // Display Error Message
      this.showDivForPrivacyMaximumhit = true;
      return;
    }


    this.clicked = true;
    this.stepFourForm.get('googleDeviceType').setValidators(Validators.compose([Validators.required, Validators.minLength(2), Validators.maxLength(150), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")]));
    this.stepFourForm.get('googleDeviceType').updateValueAndValidity();

    this.stepFourForm.get('googleDeviceModelName').setValidators(Validators.compose([Validators.required, Validators.minLength(2), Validators.maxLength(150), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")]));
    this.stepFourForm.get('googleDeviceModelName').updateValueAndValidity();

    this.stepFourForm.get('serialOrImeiNumberPrivacy').setValidators(Validators.compose([Validators.required, Validators.minLength(10), Validators.maxLength(25), Validators.pattern("^[a-zA-Z0-9]+$")]));
    this.stepFourForm.get('serialOrImeiNumberPrivacy').updateValueAndValidity();


    if (this.stepFourForm.get('googleDeviceType').invalid || this.stepFourForm.get('googleDeviceModelName').invalid || this.stepFourForm.get('serialOrImeiNumberPrivacy').invalid) {
      return;
    }

    const options: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    };


    let sL = new Array();
    sL = [{
      TableType: 'Privacy',
      GoogleDeviceType: this.stepFourForm.get('googleDeviceType').value,
      GoogleDeviceModelName: this.stepFourForm.get('googleDeviceModelName').value,
      SerialOrImeiNumberPrivacy: this.stepFourForm.get('serialOrImeiNumberPrivacy').value,
    }];

    for (let i = 0; i < sL.length; i++) {
      this.saleList.push(sL[i]);
    }

    // Issue 1300: Clear minimum entry warning after adding first entry
    this.showDivForPrivacyMinimumhit = false;

    this.stepFourForm.get('googleDeviceType').setValue('');
    this.stepFourForm.get('googleDeviceType').clearValidators();
    this.stepFourForm.get('googleDeviceType').updateValueAndValidity();
    this.stepFourForm.get('googleDeviceType').markAsUntouched();
    this.stepFourForm.get('googleDeviceType').markAsPristine();

    this.stepFourForm.get('googleDeviceModelName').setValue('');
    this.stepFourForm.get('googleDeviceModelName').clearValidators();
    this.stepFourForm.get('googleDeviceModelName').updateValueAndValidity();
    this.stepFourForm.get('googleDeviceModelName').markAsUntouched();
    this.stepFourForm.get('googleDeviceModelName').markAsPristine();


    this.stepFourForm.get('serialOrImeiNumberPrivacy').setValue('');
    this.stepFourForm.get('serialOrImeiNumberPrivacy').clearValidators();
    this.stepFourForm.get('serialOrImeiNumberPrivacy').updateValueAndValidity();
    this.stepFourForm.get('serialOrImeiNumberPrivacy').markAsUntouched();
    this.stepFourForm.get('serialOrImeiNumberPrivacy').markAsPristine();

    this.showMessage = false;
    this.clicked = false;

    /*(<FormArray>this.stepThreeForm.get('sales')).push(this.newSale());*/
  }




  removePurchasesRow(i: number) {
    this.purchaseList.splice(i, 1);
    this.showDivForPurchaseMaximumhit = false;
  }

  removeSalesRow(i: number) {
    this.saleList.splice(i, 1);
    this.showDivForPrivacyMaximumhit = false;
  }

  getFileDetails(e) {

    for (let i = 0; i < e.target.files.length; i++) {
      this.supportingDocuments.push(e.target.files[i]);
    }
  }

  removeRow(i: number) {
    this.supportingDocuments.splice(i, 1);
    this.fileInput.nativeElement.value = null;
  }
  get stepOneData(): any {
    return this.dataService.stepOneSharedData;
  }
  get stepTwoData(): any {
    return this.dataService.stepTwoSharedData;
  }
  get stepThreeData(): any {
    return this.dataService.stepThreeSharedData;
  }
  get stepThreeDataPurchases(): any {
    return this.dataService.stepThreeSharedDataPurchases;
  }

  get stepFourData(): any {
    return this.dataService.stepFourSharedData;
  }
  get stepFourDataSales(): any {
    return this.dataService.stepFourSharedDataSales;
  }
  get stepFiveData(): any {
    return this.dataService.stepFiveSharedData;
  }
  get stepSixData(): any {
    return this.dataService.stepSixSharedData;
  }

  buildClaimDetailList(newList: any) {
    for (let i = 0; i < newList.length; i++) {
      this.claimDetailList.push(newList[i]);
    }
  }

  onSubmit() {
    this.submitted = true;
    if (this.stepSevenForm.invalid) {
      this.showDivSubmittalErrorMessage = true;
      return;
    }
    this.submitClicked = true;
    this.clicked = true;
    const claimant = this.stepSevenForm.value;
    this.dateLoaded = new Date();
    this.claimEndTime = this.dateLoaded.toLocaleTimeString();



    this.buildClaimDetailList(this.stepThreeDataPurchases);
    this.buildClaimDetailList(this.stepFourDataSales);

   

    claimant.optSectionRadio = this.stepTwoData.optSectionRadio;
    claimant.classMemberName = this.stepTwoData.classMemberName;
    claimant.guardianName = this.stepTwoData.guardianName;
    claimant.street1 = this.stepTwoData.street1;
    claimant.street2 = this.stepTwoData.street2;
    claimant.city = this.stepTwoData.city;
    claimant.state = this.stepTwoData.state;
    claimant.zip = this.stepTwoData.zip;

    claimant.claimsIncurredStreet1 = this.stepTwoData.claimsIncurredStreet1;
    claimant.claimsIncurredStreet2 = this.stepTwoData.claimsIncurredStreet2;
    claimant.claimsIncurredCity = this.stepTwoData.claimsIncurredCity;
    claimant.claimsIncurredState = this.stepTwoData.claimsIncurredState;
    claimant.claimsIncurredZip = this.stepTwoData.claimsIncurredZip;

    claimant.primaryPhone = this.stepTwoData.primaryPhone;
    claimant.primaryPhoneType = this.stepTwoData.primaryPhoneType;
    claimant.emailAddress = this.stepTwoData.emailAddress;
    claimant.emailAddressVerify = this.stepTwoData.emailAddressVerify;

    claimant.settlementClassPurchaser = this.stepThreeData.settlementClassPurchaser;
    claimant.googleMadeDeviceEmailAddress = this.stepThreeData.googleMadeDeviceEmailAddress;

    claimant.settlementClassPrivacy = this.stepFourData.settlementClassPrivacy;
    claimant.userOrMember = this.stepFourData.userOrMember;
    claimant.associatedGoogleAccountName = this.stepFourData.associatedGoogleAccountName;
    claimant.associatedGoogleAccountEmailAddress = this.stepFourData.associatedGoogleAccountEmailAddress;

    claimant.optPaymentRadio = this.stepSixData.optPaymentRadio;
    claimant.achAccountType = this.stepSixData.achAccountType;
    claimant.achRoutingNumber = this.stepSixData.achRoutingNumber;
    claimant.achAccountNumber = this.stepSixData.achAccountNumber;

    claimant.checkbox1 = this.stepSevenForm.get('checkbox1').value;
    claimant.checkbox2 = this.stepSevenForm.get('checkbox2').value;
    claimant.checkbox3 = this.stepSevenForm.get('checkbox3').value;
    claimant.checkbox4 = this.stepSevenForm.get('checkbox4').value;
    claimant.checkbox5 = this.stepSevenForm.get('checkbox5').value;
    claimant.checkbox6 = this.stepSevenForm.get('checkbox6').value;


    claimant.checkBoxMemberOfPurchaserClass = this.stepSevenForm.get('checkBoxMemberOfPurchaserClass')?.value;
    claimant.checkboxPurchaserGoogleAccountConfirmation = this.stepSevenForm.get('checkboxPurchaserGoogleAccountConfirmation')?.value;
    claimant.checkBoxMemberOfPrivacyClass = this.stepSevenForm.get('checkBoxMemberOfPrivacyClass')?.value;

    claimant.attestMemberOfPrivacyClass = this.stepSevenForm.get('attestMemberOfPrivacyClass')?.value;
    claimant.attestMemberOfPrivacyClassSelection = this.stepSevenForm.get('attestMemberOfPrivacyClassSelection').value;
    claimant.checkBoxPrivacyCommunicationsRecorded = this.stepSevenForm.get('checkBoxPrivacyCommunicationsRecorded')?.value;

    claimant.noticeId = this.stepSevenForm.get('noticeId').value;
    claimant.uniqueId = this.stepSevenForm.get('uniqueId').value;
    claimant.pin = this.stepSevenForm.get('pin').value;

    claimant.signature = this.stepSevenForm.get('signature').value;
    claimant.googleRecaptchaToken = this.stepSevenForm.get('googleRecaptchaToken').value;
    claimant.claimDetail = this.claimDetailList;

    claimant.claimStartTime = this.claimStartTime;
    claimant.claimEndTime = this.claimEndTime;

    this.spinner.show();
    this.CreateClaimant(claimant);
  }



  CreateClaimant(claimant: Claimant) {
    const message = "Unable to save claimant data.";

    this.claimantService.createClaimant(claimant).subscribe(res => {
      this.submittedClaim = res;
      if (this.submittedClaim.statusMessage === message) {
        this.showSubmittalErrorWarning = true;
        return;
      }
      this.SubmitDocuments(this.submittedClaim.claimNumber);
    });
  }

  SubmitDocuments(claimNumber: string) {
    this.claimantService.submitDocuments(this.submittedClaim.claimNumber, this.stepFiveData).subscribe(() => {
    });
    this.storage.store('claimant', this.submittedClaim);
    // this.dataSaved = true;
    // this.submitted = false;
    // this.notSubmitted = false;
    // this.message = "Record Saved Successfully";
    this.stepSixForm.reset();
    this.spinner.hide();
    this.router.navigate(['/complete']);
  }
}
